/* Little Boudoir — moteur de personnalisation maison (v3, PERSO-MODELE.md §3.3).
   1. Validation des requis au clic (Dawn soumet en fetch : la validation
      native ne se déclenche pas seule).
   2. Compteurs, conditions par tableau (toutes / une_au_moins, afficher / masquer,
      cascade : un champ masqué n'a pas de valeur), groupes repliables, listes
      d'images (details), zoom des vignettes.
   3. Total dynamique en centimes : prix du variant + suppléments (suit le pubsub
      variantChange de Dawn).
   4. Suppléments = variantes ajoutées après l'ajout principal, liées par une clé
      (_lb_cle sur la ligne principale, _lb_pour sur les suppléments) ; échec =>
      article principal retiré + message (zéro sous-facturation silencieuse) ;
      lb-ajax-cart.js synchronise suppression, quantités et re-rendu.
   5. Interrupteur Globo (theme.liquid) : ce script ne fait rien si Globo est actif
      (html.lb-globo) ; si Globo apparaît après coup, lbp:desactive le met hors jeu
      (drapeau « mort » : plus aucune clé, plus aucun supplément ajouté).
   6. properties[_lb_sups] (caché) : liste des suppléments attendus sur la ligne
      principale -> lb-ajax-cart.js répare si un supplément manque (onglet fermé ou
      erreur entre les deux ajouts).
   7. Cartes répétées (« Charm 1 », « Charm 2 »…, rendues par lb-perso-carte) : masquées quand
      toutes leurs questions le sont ; un choix gratuit de la 1re carte est repris dans les
      suivantes encore vides (data-lbp-auto), jamais par-dessus un choix de la cliente. */
(function () {
  if (window.lbPerso) window.lbPerso.verifier();
  if (!document.documentElement.classList.contains('lb-maison')) return;
  var root = document.querySelector('[data-lb-perso]');
  if (!root) return;
  var form = root.closest('form');
  if (!form) return;
  var mort = false;

  function euros(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  /* supplément : même écriture que sur les boutons, vignettes et menus (« +2 € », « +1,90 € ») */
  function eurosCourt(cents) { return cents % 100 ? euros(cents) : (cents / 100) + ' €'; }

  /* --- compteurs --- */
  root.querySelectorAll('[data-lbp-compte]').forEach(function (input) {
    var count = input.parentElement.querySelector('.lbp-count b');
    if (!count) return;
    input.addEventListener('input', function () { count.textContent = input.value.length; });
  });

  /* --- groupes repliables --- */
  function deplierGroupe(fs, ouvert) {
    var corps = fs.querySelector('.lbp-groupe__corps');
    if (!corps) return;
    corps.hidden = !ouvert;
    var btn = fs.querySelector('.lbp-groupe__toggle');
    if (btn) btn.setAttribute('aria-expanded', String(ouvert));
    fs.classList.toggle('lbp-groupe--ouvert', ouvert);
  }
  root.querySelectorAll('[data-lbp-replie]').forEach(function (fs) {
    var legend = fs.querySelector('legend');
    var corps = fs.querySelector('.lbp-groupe__corps');
    if (!legend || !corps) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'lbp-groupe__toggle'; btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = legend.innerHTML + ' <span aria-hidden="true">▾</span>';
    legend.innerHTML = ''; legend.appendChild(btn);
    corps.hidden = true;
    btn.addEventListener('click', function () { deplierGroupe(fs, corps.hidden); });
  });

  /* --- bulle d'aide « ? » : jamais hors de l'écran (décalée vers l'intérieur à l'ouverture) --- */
  function placerAide(d) {
    var pop = d.querySelector('.lbp-aide__pop');
    if (!pop || !d.open) return;
    pop.style.left = ''; pop.style.transform = '';
    var r = pop.getBoundingClientRect();
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var marge = 8, dx = 0;
    if (r.right > vw - marge) dx = (vw - marge) - r.right;
    if (r.left + dx < marge) dx = marge - r.left;
    /* position posée en px (sans transform) : la page ne garde aucune largeur fantôme */
    if (dx) { pop.style.transform = 'none'; pop.style.left = Math.round(r.left + dx - d.getBoundingClientRect().left) + 'px'; }
  }
  root.querySelectorAll('.lbp-aide').forEach(function (d) {
    d.addEventListener('toggle', function () { placerAide(d); });
  });
  window.addEventListener('resize', function () {
    root.querySelectorAll('.lbp-aide[open]').forEach(placerAide);
  });

  /* --- listes d'images (details/summary) : résumé = choix courant, fermeture au choix --- */
  root.querySelectorAll('[data-lbp-imgselect]').forEach(function (det) {
    var resume = det.querySelector('[data-lbp-imgselect-resume]');
    var vide = resume ? resume.innerHTML : '';
    function maj() {
      if (!resume) return;
      var checked = det.querySelector('input:checked');
      if (!checked) { resume.innerHTML = vide; return; }   /* choix effacé quand la question a été cachée */
      var thumb = checked.closest('.lbp-thumb');
      var img = thumb && thumb.querySelector('img');
      resume.innerHTML = (img ? '<img src="' + img.src + '" alt="" width="28" height="28"> ' : '') + checked.value;
    }
    det.addEventListener('change', function () { maj(); det.open = false; });
    det.addEventListener('lbp:efface', maj);
    maj();
  });

  /* --- zoom des vignettes --- */
  var zoomDlg = null;
  function ouvrirZoom(src, alt) {
    if (!zoomDlg) {
      zoomDlg = document.createElement('dialog');
      zoomDlg.className = 'lbp-zoom';
      zoomDlg.innerHTML = '<button type="button" class="lbp-zoom__close" aria-label="Fermer">×</button><img alt=""><p></p>';
      document.body.appendChild(zoomDlg);
      zoomDlg.querySelector('.lbp-zoom__close').addEventListener('click', function () { zoomDlg.close(); });
      zoomDlg.addEventListener('click', function (e) { if (e.target === zoomDlg) zoomDlg.close(); });
    }
    zoomDlg.querySelector('img').src = src;
    zoomDlg.querySelector('p').textContent = alt || '';
    if (typeof zoomDlg.showModal === 'function') zoomDlg.showModal(); else zoomDlg.setAttribute('open', '');
  }
  root.querySelectorAll('.lbp-thumbs--zoom img[data-lbp-zoom]').forEach(function (img) {
    var thumb = img.closest('.lbp-thumb');
    if (!thumb) return;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'lbp-thumb__zoom'; btn.setAttribute('aria-label', 'Agrandir'); btn.textContent = '⤢';
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var input = thumb.querySelector('input');
      ouvrirZoom(img.dataset.lbpZoom, input ? input.value : '');
    });
    thumb.appendChild(btn);
  });

  /* --- conditions (par tableau, avec cascade) --- */
  function valeurDuChamp(handle) {
    var dep = root.querySelector('[data-lbp-field="' + handle + '"]');
    if (!dep || dep.hidden) return '';               /* un champ masqué n'a pas de valeur */
    var checked = dep.querySelector('input:checked');
    if (checked) return checked.value;
    var select = dep.querySelector('select');
    if (select) return select.value;
    var t = dep.querySelector('input[type="text"], input[type="date"], textarea');
    return t ? t.value : '';
  }
  var conditionnels = [];
  root.querySelectorAll('[data-lbp-si]').forEach(function (bloc) {
    var regles = [];
    try { regles = JSON.parse(bloc.dataset.lbpSi || '[]'); } catch (e) { regles = []; }
    conditionnels.push({ bloc: bloc, regles: regles, mode: bloc.dataset.lbpSiMode || 'toutes', effet: bloc.dataset.lbpSiEffet || 'afficher' });
  });
  function evaluer(c) {
    if (!c.regles.length) return true;
    var verites = c.regles.map(function (r) {
      var v = valeurDuChamp(r.c);
      return v !== '' && (r.v || []).indexOf(v) !== -1;
    });
    var vrai = c.mode === 'une_au_moins' ? verites.some(Boolean) : verites.every(Boolean);
    return c.effet === 'masquer' ? !vrai : vrai;
  }
  /* Choix de la cliente dans une carte répétée (« Charm 2 ») : retenu quand la carte est cachée
     (data-lbp-garde), remis quand elle revient — jamais remplacé par un choix repris. */
  var restaure = false;
  function restaurer(field) {
    var v = field.getAttribute('data-lbp-garde');
    if (v === null) return;
    field.removeAttribute('data-lbp-garde');
    if (field.querySelector('input[type="radio"]:checked')) return;
    var r = null;
    field.querySelectorAll('input[type="radio"]').forEach(function (i) {
      if (!r && i.value === v && !i.disabled) r = i;
    });
    if (r) { r.checked = true; restaure = true; }
  }
  function applyConditions() {
    restaure = false;
    /* jusqu'à stabilité (chaînes de conditions), 3 passes max */
    for (var passe = 0; passe < 3; passe++) {
      var change = false;
      conditionnels.forEach(function (c) {
        var show = evaluer(c);
        var reaffiche = false;
        if (c.bloc.hidden !== !show) { c.bloc.hidden = !show; change = true; reaffiche = show; }
        c.bloc.querySelectorAll('[data-lbp-input]').forEach(function (i) {
          /* un champ caché ne valide pas et n'envoie pas sa propriété ;
             on n'écrase pas le disabled des valeurs épuisées/indisponibles */
          if (i.closest('.lbp-pill--off, .lbp-thumb--off') || (i.tagName === 'OPTION' && i.disabled)) return;
          i.disabled = !show;
        });
        if (reaffiche) restaurer(c.bloc);
      });
      if (!change) break;
    }
    /* Un choix resté coché dans une question cachée compte encore pour le navigateur :
       deux questions « Couleur » (une par modèle) partagent le même nom, donc le même
       groupe de boutons, et l'ancienne couleur satisfaisait la question obligatoire
       visible alors que rien n'y était choisi — la commande partait sans couleur
       (porte-clés Modèle flex, Les Griottes). On décoche donc ce qui reste caché, une fois
       l'affichage stabilisé (une question cachée puis réaffichée dans les passes garde son choix). */
    conditionnels.forEach(function (c) {
      if (!c.bloc.hidden) {
        if (restaure) c.bloc.querySelectorAll('[data-lbp-imgselect]').forEach(function (d) {
          d.dispatchEvent(new CustomEvent('lbp:efface'));   /* résumé = choix remis */
        });
        return;
      }
      var efface = false;
      /* choix de la cliente dans une carte : retenu avant d'être décoché (remis au retour) */
      if (c.bloc.closest('[data-lbp-carte]') && c.bloc.hasAttribute('data-lbp-choisi') && !c.bloc.hasAttribute('data-lbp-auto')) {
        var garde = c.bloc.querySelector('input[type="radio"]:checked');
        if (garde) c.bloc.setAttribute('data-lbp-garde', garde.value);
      }
      c.bloc.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach(function (i) {
        i.checked = false; efface = true;
      });
      if (efface) c.bloc.querySelectorAll('[data-lbp-imgselect]').forEach(function (d) {
        d.dispatchEvent(new CustomEvent('lbp:efface'));
      });
    });
    /* une carte répétée (« Charm 3 ») disparaît quand toutes ses questions sont cachées */
    root.querySelectorAll('[data-lbp-carte]').forEach(function (carte) {
      carte.hidden = !carte.querySelector('[data-lbp-field]:not([hidden])');
    });
    if (restaure) { restaure = false; root.dispatchEvent(new CustomEvent('lbp:maj')); }
  }
  /* Une question touchée par la cliente porte data-lbp-choisi (pour toujours) : elle ne sera plus
     jamais pré-cochée par la reprise, et son choix est retenu si sa carte est cachée. Un clic (ou
     Espace/Entrée) sur un choix déjà pré-coché le confirme : il n'envoie pas de « change ». */
  function choixCliente(el) {
    if (enReprise || !el || !el.closest) return;
    var f = el.closest('[data-lbp-field]');
    if (!f) return;
    f.removeAttribute('data-lbp-auto');
    f.setAttribute('data-lbp-choisi', '');
  }
  root.addEventListener('change', function (e) { choixCliente(e.target); });
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest || t.closest('.lbp-thumb__zoom')) return;
    var choix = t.closest('.lbp-pill, .lbp-thumb');
    var input = choix && choix.querySelector('input[type="radio"]');
    if (input && !input.disabled) choixCliente(input);
  });
  root.addEventListener('keydown', function (e) {
    if ((e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') && e.target.matches && e.target.matches('input[type="radio"]') && !e.target.disabled) {
      if (e.key === 'Enter') e.preventDefault();   /* Entrée sur un choix confirme, n'ajoute pas au panier */
      choixCliente(e.target);
    }
  });
  /* Écrire dans une carte (« Texte intérieur jonc 2 ») confirme les choix pré-cochés de la même
     carte qui font apparaître ce texte : changer le jonc 1 ne fera plus disparaître ce qui est tapé. */
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (enReprise || !t.matches || !t.matches('input[type="text"], textarea')) return;
    var f = t.closest('[data-lbp-field]');
    var carte = f && f.closest('[data-lbp-carte]');
    if (!carte) return;
    conditionnels.forEach(function (c) {
      if (c.bloc !== f) return;
      c.regles.forEach(function (r) {
        var dep = root.querySelector('[data-lbp-field="' + r.c + '"]');
        if (dep && dep.hasAttribute('data-lbp-auto') && dep.closest('[data-lbp-carte]') === carte) {
          dep.removeAttribute('data-lbp-auto');
          dep.setAttribute('data-lbp-choisi', '');
        }
      });
    });
  });
  root.addEventListener('change', applyConditions);
  root.addEventListener('input', function (e) { if (e.target.matches('input[type="text"], textarea')) applyConditions(); });
  applyConditions();

  /* --- choix repris d'une carte à l'autre ---
     Cartes répétées (lb-perso-carte : « Charm 1 », « Charm 2 »…) : un CHOIX fait dans la
     première carte d'une série (même modèle, même typographie) est pré-coché dans les cartes
     suivantes affichées dont la même question est encore vide. Jamais un texte, jamais un choix
     payant (pas de supplément ajouté à l'insu), jamais par-dessus un choix fait par la cliente :
     une question pré-cochée porte data-lbp-auto, qui tombe dès que la cliente y touche ; une
     question que la cliente a touchée (data-lbp-choisi) n'est plus jamais pré-cochée. */
  var series = [];
  (function () {
    var parSerie = {};
    root.querySelectorAll('[data-lbp-carte][data-lbp-serie]').forEach(function (carte) {
      var s = carte.dataset.lbpSerie;
      if (!parSerie[s]) { parSerie[s] = { cartes: [] }; series.push(parSerie[s]); }
      parSerie[s].cartes.push(carte);
    });
    series = series.filter(function (s) { return s.cartes.length > 1; });
    series.forEach(function (s) {
      s.sources = [];
      s.cartes[0].querySelectorAll('[data-lbp-field][data-lbp-sous]').forEach(function (f) {
        if (!f.querySelector('input[type="radio"], select')) return;   /* textes : jamais repris */
        var note = document.createElement('p');
        note.className = 'lbp-repris'; note.hidden = true; note.setAttribute('aria-live', 'polite');
        /* formulation neutre : juste quel que soit le mot de la série (charm, ligne, jonc…) */
        note.textContent = 'Choix repris plus bas (modifiable)';
        f.appendChild(note);
        s.sources.push({ champ: f, sous: f.dataset.lbpSous, note: note });
      });
    });
  })();
  function choixDe(field) {
    if (!field || field.hidden) return null;
    var r = field.querySelector('input[type="radio"]:checked');
    if (r) return r;
    var sel = field.querySelector('select');
    if (sel && sel.value) return sel.options[sel.selectedIndex];
    return null;
  }
  function memeQuestion(carte, sous) {
    var champs = carte.querySelectorAll('[data-lbp-field][data-lbp-sous]');
    for (var i = 0; i < champs.length; i++) if (champs[i].dataset.lbpSous === sous) return champs[i];
    return null;
  }
  function cocher(field, valeur) {
    var cible = null;
    field.querySelectorAll('input[type="radio"], option').forEach(function (el) {
      if (!cible && el.value === valeur && !el.disabled) cible = el;
    });
    if (!cible || cible.dataset.lbpSupVariant) return false;   /* absent, épuisé ou payant */
    if (cible.tagName === 'OPTION') {
      var sel = cible.closest('select');
      sel.value = valeur;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      cible.checked = true;
      cible.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }
  var enReprise = false;
  function reprendre() {
    if (enReprise || !series.length) return;
    enReprise = true;
    try {
      series.forEach(function (s) {
        s.sources.forEach(function (src) {
          var choisi = choixDe(src.champ);
          var valeur = choisi && !choisi.dataset.lbpSupVariant ? choisi.value : '';
          var suivantes = 0;
          s.cartes.slice(1).forEach(function (carte) {
            var f = memeQuestion(carte, src.sous);
            if (!f || f.hidden) return;
            suivantes++;
            if (!valeur) return;
            if (f.hasAttribute('data-lbp-choisi')) return;   /* déjà touchée par la cliente : jamais pré-cochée */
            var actuel = choixDe(f);
            if (actuel && !f.hasAttribute('data-lbp-auto')) return;   /* choix de la cliente */
            if (actuel && actuel.value === valeur) return;
            if (cocher(f, valeur)) f.setAttribute('data-lbp-auto', '');
          });
          src.note.hidden = !(valeur && suivantes > 0);
        });
      });
    } finally { enReprise = false; }
  }
  /* (la cliente qui touche une question pré-cochée la fait sienne : voir choixCliente) */
  root.addEventListener('change', function () { if (!enReprise) reprendre(); });
  reprendre();

  /* --- lettres payées = lettres tapées ---
     Une question dont TOUS les choix sont des nombres de lettres (« 7 lettres », « 4 à 6 lettres »,
     « 15 cm - 7 à 9 lettres » ; son titre importe peu : « Sélectionner » sur le tricotin) fixe le
     prix du texte tapé dans LA zone de texte libre du modèle (tricotin, guirlande, mot mural…) :
     7 lettres tapées = 7 lettres payées, jamais moins (espaces non comptés). En tapant,
     le bon nombre est choisi tout seul s'il n'y en a qu'un possible ; sinon l'ajout est refusé tant
     que le choix ne colle pas. Les modèles à une case par lettre ou par charm (« Lettre 3 »,
     « Texte recto Charm 3 ») sont déjà liés par leurs questions : non concernés. */
  var RE_LETTRES = /(\d+)(?:\s*à\s*(\d+))?\s*lettres?\b/i;
  function plage(v) {
    var m = RE_LETTRES.exec(v || '');
    return m ? { min: +m[1], max: +(m[2] || m[1]), avant: v.slice(0, m.index) } : null;
  }
  var accords = [];
  (function () {
    var nombres = [];
    root.querySelectorAll('[data-lbp-field]').forEach(function (f) {
      var choix = [].slice.call(f.querySelectorAll('input[type="radio"], option')).filter(function (c) { return c.value; });
      if (choix.length > 1 && choix.every(function (c) { return plage(c.value); })) nombres.push({ champ: f, choix: choix });
    });
    if (!nombres.length) return;
    var textes = [].slice.call(root.querySelectorAll('[data-lbp-field] input[type="text"], [data-lbp-field] textarea'));
    /* une case par lettre (« Lettre 3 ») : déjà liée au nombre ; un autre texte (message) ne compte pas */
    if (textes.some(function (t) { return t.maxLength === 1; })) return;
    var libres = textes;
    if (libres.length > 1) libres = libres.filter(function (t) { return /pr[ée]nom|texte|mot/i.test(t.closest('[data-lbp-field]').dataset.lbpNom || ''); });
    if (libres.length !== 1) return;   /* plusieurs textes possibles : on ne devine pas lequel compte */
    var texte = libres[0];
    var alerte = document.createElement('p');
    alerte.className = 'lbp-erreur'; alerte.hidden = true; alerte.setAttribute('aria-live', 'polite');
    texte.closest('[data-lbp-field]').appendChild(alerte);
    nombres.forEach(function (n) {
      var note = document.createElement('p');
      note.className = 'lbp-repris'; note.hidden = true; note.setAttribute('aria-live', 'polite');
      n.champ.appendChild(note);
      accords.push({ champ: n.champ, choix: n.choix, texte: texte, alerte: alerte, note: note });
    });
  })();
  function nbLettres(t) { return Array.from((t.value || '').replace(/\s+/g, '')).length; }
  function choixNombre(a) {
    var sel = a.champ.querySelector('select');
    if (sel) return sel.value ? sel.options[sel.selectedIndex] : null;
    return a.champ.querySelector('input[type="radio"]:checked');
  }
  function accorder(a, auto) {
    var n = a.champ.hidden || a.texte.disabled ? 0 : nbLettres(a.texte);
    var actuel = choixNombre(a);
    var p = actuel && plage(actuel.value);
    var ok = !n || !!(p && n >= p.min && n <= p.max);
    if (!ok && auto) {
      var bons = a.choix.filter(function (c) {
        var r = plage(c.value);
        return !c.disabled && !c.closest('.lbp-pill--off, .lbp-thumb--off') && n >= r.min && n <= r.max;
      });
      var memeTaille = p ? bons.filter(function (c) { return plage(c.value).avant === p.avant; }) : [];
      var cible = bons.length === 1 ? bons[0] : (memeTaille.length === 1 ? memeTaille[0] : null);
      if (cible) {
        if (cible.tagName === 'OPTION') {
          var s = cible.closest('select'); s.value = cible.value;
          s.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          cible.checked = true;
          cible.dispatchEvent(new Event('change', { bubbles: true }));
        }
        a.note.textContent = 'Ajusté à votre texte (' + n + ' lettre' + (n > 1 ? 's' : '') + ')';
        a.note.hidden = false;
        return;   /* le « change » ci-dessus relance la vérification */
      }
    }
    var msg = '';
    if (!ok) {
      var max = Math.max.apply(null, a.choix.map(function (c) { return plage(c.value).max; }));
      var lettres = n + ' lettre' + (n > 1 ? 's' : '');
      msg = n > max
        ? 'Maximum ' + max + ' lettres : votre texte en compte ' + n + '.'
        : 'Votre texte compte ' + lettres + ' : choisissez « ' + (a.champ.dataset.lbpNom || 'Nombre de lettres') + ' » pour ' + lettres + '.';
    }
    if (!n) a.note.hidden = true;
    a.texte.setCustomValidity(msg);
    a.alerte.textContent = msg;
    a.alerte.hidden = !msg;
  }
  if (accords.length) {
    root.addEventListener('input', function (e) {
      accords.forEach(function (a) { if (e.target === a.texte) accorder(a, true); });
    });
    root.addEventListener('change', function (e) {
      accords.forEach(function (a) {
        if (e.target === a.texte) accorder(a, true);
        else if (a.champ.contains(e.target)) { if (e.isTrusted) a.note.hidden = true; accorder(a, false); }
        else accorder(a, false);   /* question cachée / réaffichée par une condition */
      });
    });
    accords.forEach(function (a) { accorder(a, true); });
  }

  /* --- suppléments sélectionnés + totaux (centimes) --- */
  function selectedSupplements() {
    var out = [];
    root.querySelectorAll('[data-lbp-input]').forEach(function (i) {
      if (i.disabled) return;
      var el = null;
      if (i.tagName === 'SELECT') { var opt = i.options[i.selectedIndex]; if (opt && opt.dataset.lbpSupVariant) el = opt; }
      else if (i.type === 'radio' && i.checked && i.dataset.lbpSupVariant) el = i;
      if (!el) return;
      var field = i.closest('[data-lbp-field]');
      out.push({
        variant: el.dataset.lbpSupVariant,
        prix: parseInt(el.dataset.lbpSupPrix || '0', 10),
        libelle: (field && field.dataset.lbpNom ? field.dataset.lbpNom : '') + ' : ' + (el.dataset.lbpSupNom || el.value)
      });
    });
    return out;
  }
  var basePrice = parseInt(root.dataset.lbpBase, 10) || 0;
  function refreshTotals() {
    var sups = selectedSupplements();
    var supCents = sups.reduce(function (s, x) { return s + x.prix; }, 0);
    var supBox = root.querySelector('[data-lbp-suptotal]');
    if (supBox) {
      supBox.hidden = supCents <= 0;
      var sv = supBox.querySelector('[data-lbp-suptotal-val]');
      if (sv) sv.textContent = '+' + eurosCourt(supCents);
    }
    var totBox = root.querySelector('[data-lbp-total]');
    if (totBox) {
      totBox.hidden = supCents <= 0;
      var tv = totBox.querySelector('[data-lbp-total-val]');
      if (tv) tv.textContent = euros(basePrice + supCents);
    }
  }
  root.addEventListener('change', refreshTotals);
  root.addEventListener('lbp:maj', refreshTotals);   /* choix remis au retour d'une carte */
  refreshTotals();

  /* le prix de base suit le variant sélectionné */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
      try {
        var v = evt && evt.data && evt.data.variant;
        if (v && v.price != null) { basePrice = v.price; refreshTotals(); }
      } catch (e) {}
    });
  }

  /* --- clé de liaison principal <-> suppléments ---
     Dawn capture le FormData dans SON écouteur submit, enregistré avant le nôtre :
     la clé doit exister AVANT le submit. Posée au clic (phase capture) ; pas de
     nouvelle clé tant que Dawn est en cours d'ajout (aria-disabled). */
  var cleInput = document.createElement('input');
  cleInput.type = 'hidden'; cleInput.name = 'properties[_lb_cle]';
  form.appendChild(cleInput);
  /* suppléments attendus, figés au moment de la clé : {"t":horodatage,"s":[{"v":variante,"o":libellé}]} ;
     désactivé (donc non envoyé) quand il n'y a aucun supplément */
  var supsInput = document.createElement('input');
  supsInput.type = 'hidden'; supsInput.name = 'properties[_lb_sups]'; supsInput.disabled = true;
  form.appendChild(supsInput);
  /* ajouts envoyés dont on attend la réponse : clé -> suppléments figés au clic
     (plusieurs possibles : double clic, réseau lent) */
  var attentes = {};
  var enVol = window.lbPerso ? (window.lbPerso.enVol = window.lbPerso.enVol || {}) : {};
  function nouvelleCle() { return 'k' + Date.now().toString(36) + Math.floor(Math.random() * 1e4).toString(36); }
  function poserCle() {
    if (mort) return;
    var cle = nouvelleCle();
    var sups = selectedSupplements();
    cleInput.value = cle;
    supsInput.value = sups.length ? JSON.stringify({
      t: Date.now(),
      s: sups.map(function (s) { return { v: parseInt(s.variant, 10), o: s.libelle }; })
    }) : '';
    supsInput.disabled = !sups.length;
    attentes[cle] = sups;
    /* lb-ajax-cart.js ne répare pas une clé en cours d'ajout ; passé 30 s, la réparation
       reprend la main (réponse jamais arrivée) */
    enVol[cle] = true;
    setTimeout(function () {
      if (!enVol[cle]) return;
      delete enVol[cle];
      delete attentes[cle];
      if (window.lbCartSync) window.lbCartSync.lancer();
    }, 30000);
  }

  /* Globo détecté après coup : on se retire (plus de clé, plus de supplément). */
  document.addEventListener('lbp:desactive', function () {
    mort = true;
    attentes = {};
    cleInput.remove();
    supsInput.remove();
  });

  /* --- validation au clic (avant le fetch de Dawn) ---
     Entrée dans un champ = clic implicite sur le bouton : même chemin. Un submit sans clic
     (requestSubmit d'un autre script) est validé dans l'écouteur submit ci-dessous. */
  var cleFraiche = false;
  function valider() {
    var bad = null;
    root.querySelectorAll('[data-lbp-input]').forEach(function (i) {
      if (bad || i.disabled) return;
      if (!i.checkValidity()) bad = i;
    });
    if (!bad) return true;
    var det = bad.closest('details'); if (det) det.open = true;
    var fs = bad.closest('[data-lbp-replie]'); if (fs) deplierGroupe(fs, true);
    bad.reportValidity();
    var field = bad.closest('.lbp-field');
    if (field) { field.classList.add('lbp-field--err'); field.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    return false;
  }
  var submitBtn = form.querySelector('[type="submit"], [name="add"]');
  if (submitBtn) {
    submitBtn.addEventListener('click', function (e) {
      if (mort) return;
      if (!valider()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      if (submitBtn.getAttribute('aria-disabled') === 'true' || submitBtn.disabled) return;
      poserCle();
      cleFraiche = true;
    }, true);
  }
  ['change', 'input'].forEach(function (type) {
    root.addEventListener(type, function (e) {
      var f = e.target.closest('.lbp-field'); if (f) f.classList.remove('lbp-field--err');
    });
  });
  form.addEventListener('submit', function (e) {
    if (mort) return;
    /* Dawn ignore un submit pendant un ajout en cours : surtout ne pas changer la clé */
    if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') { cleFraiche = false; return; }
    if (!cleFraiche) {
      if (!valider()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      poserCle();
    }
    cleFraiche = false;
  }, true);

  /* --- ajout des suppléments après l'ajout principal --- */
  function afficherErreur(msg) {
    var pf = form.closest('product-form');
    var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    if (wrap) {
      var txt = wrap.querySelector('.product-form__error-message');
      if (txt) txt.textContent = msg;
      wrap.removeAttribute('hidden');
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      window.alert(msg);
    }
  }
  function cleDeLigne(cle) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var it = (cart.items || []).filter(function (i) { return i.properties && i.properties._lb_cle === cle; })[0];
        return it ? it.key : null;
      });
  }
  function retirerLigne(key) {
    if (!key) return Promise.resolve();
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).catch(function () {});
  }
  function ajouterSupplements(sups, qty, cle, mainKey, essai) {
    essai = essai || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: sups.map(function (s) {
          return { id: parseInt(s.variant, 10), quantity: qty, properties: { _lb_pour: cle, 'Option': s.libelle } };
        })
      })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, json: j }; });
      })
      .then(function (res) {
        if (!res.ok) {
          var e = new Error((res.json && (res.json.description || res.json.message)) || ('erreur ' + res.status));
          e.definitif = res.status === 422 || res.status === 404;
          throw e;
        }
        return window.lbCartRefresh ? window.lbCartRefresh() : null;
      })
      .catch(function (err) {
        if (essai < 2 && !err.definitif) return ajouterSupplements(sups, qty, cle, mainKey, essai + 1);
        var trouver = mainKey ? Promise.resolve(mainKey) : cleDeLigne(cle).catch(function () { return null; });
        return trouver.then(retirerLigne).then(function () {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.close === 'function') drawer.close();
          afficherErreur("Une option n'a pas pu être ajoutée (" + (err && err.message ? err.message : 'erreur inconnue') + "). L'article n'a pas été mis au panier : réessayez, ou contactez-nous.");
          return window.lbCartRefresh ? window.lbCartRefresh() : null;
        });
      });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      if (mort) return;
      if (evt && evt.source && evt.source !== 'product-form') return;
      /* la réponse de /cart/add porte la ligne ajoutée (avec ses propriétés) : on ne réagit
         qu'à NOS ajouts, retrouvés par leur clé (un autre formulaire de la page n'y touche pas) */
      var ligne = evt && evt.cartData;
      var cle = ligne && ligne.properties && ligne.properties._lb_cle;
      if (!cle || !attentes[cle]) return;
      var sups = attentes[cle];
      delete attentes[cle];
      if (!sups.length) { delete enVol[cle]; return; }
      var qty = parseInt(ligne.quantity, 10) > 0 ? parseInt(ligne.quantity, 10) : 1;
      var mainKey = ligne.key || null;
      /* le tiroir vient d'être dessiné AVANT l'ajout des options, qui décale les lignes :
         on bloque les lignes jusqu'au rafraîchissement (sinon « supprimer » viserait la mauvaise) */
      var verrou = window.lbCartSync && window.lbCartSync.verrouiller;
      if (verrou) verrou(true);
      var fin = function () { delete enVol[cle]; if (verrou) verrou(false); };
      ajouterSupplements(sups, qty, cle, mainKey).then(fin, fin);
    });
    /* ajout principal refusé (stock, erreur) : la clé du dernier clic n'ira pas au panier */
    if (PUB_SUB_EVENTS.cartError) subscribe(PUB_SUB_EVENTS.cartError, function (evt) {
      if (mort || (evt && evt.source && evt.source !== 'product-form')) return;
      var vid = form.querySelector('[name="id"]');
      if (evt && evt.productVariantId && vid && String(evt.productVariantId) !== String(vid.value)) return;
      var cle = cleInput.value;
      if (!attentes[cle]) return;
      delete attentes[cle];
      delete enVol[cle];
    });
  }

  /* prêt : la garde de theme.liquid laisse désormais passer l'ajout au panier */
  if (!mort) root.dataset.lbpPret = '1';
})();
